import { Button, Image, Input } from 'antd'
import React, { useEffect } from 'react'
import { View } from 'styles/reactnative'

const PopUpImage = ({ apiImages, setApiImages, images, setImages }) => {
	
	const [length, setLength] = React.useState(images?.length || 1)

	const imagestomap:any = new Map(images?.map((value, index) => [index, value]) || [])
	console.log('imagestomap', imagestomap)


	const [tempimage, setTempImage] = React.useState(imagestomap)
	const [refresh, setRefresh] = React.useState(false)

	useEffect(() => {
		//to Array
		const temp = Array.from(tempimage.values())
		temp.forEach((value, index) => {
			if (value === '') {
				temp.splice(index, 1)
			}
		})
		setImages(temp)
	}, [tempimage, refresh])

	return (
		<View
			style={{
				height: 130,
				width: '100%',
				borderBottom: '1px solid #ddd',
				padding: 3,
				overflow: 'auto',
				justifyContent: 'space-between',
				alignItems: 'flex-start',
			}}>
			{Array.from({ length: length }).map((_, index) => (
				<View
					style={{
						flexDirection: 'row',
						justifyContent: 'space-between',
						borderBottom: `1px solid #ddd`,
						padding: 3,
						width: '100%',
						alignItems: 'center',
					}}>
					<Input
						style={{ width: '80%', flex: 1 }}
						key={index}
						defaultValue={images[index]}
						onChange={e => {
							setTempImage(tempimage.set(index, e.target.value))
							setRefresh(!refresh)
						}}
					/>
					{tempimage.get(index) && (
						<Image
							src={tempimage.get(index)}
							style={{ width: '30px', height: '30px' }}
						/>
					)}
				</View>
			))}

			<Button onClick={() => setLength(length + 1)}>Add</Button>
			{/* <Upload
				name="avatar"
				listType="picture-card"
				className="avatar-uploader"
				fileList={images}
				onChange={onChange}
				beforeUpload={beforeUpload}
				style={{
					borderColor: 'blue',
				}}
				onPreview={onPreview}
				multiple={true}>
				{images.length < 4 && '+ Upload'}
			</Upload> */}
		</View>
	)
}

export default React.memo(PopUpImage)
